import { useAlerting, useTranslation } from "src/hooks";
import { EditFields } from "..";
import { usePageConfigProviderContext } from "src/features/PageConfigProvider";

function useValidation(initFields: EditFields) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const { alerting } = useAlerting();

  const validate = (fields: EditFields) => {
    try {
      const { thresholdLower, thresholdUpper } = fields;

      if (
        thresholdLower === initFields.thresholdLower &&
        thresholdUpper === initFields.thresholdUpper
      ) {
        throw t("no_change_warning");
      }

      if (!thresholdLower && !thresholdUpper) {
        throw t("no_threshold_warning");
      }

      if (thresholdLower && thresholdUpper) {
        if (Number(fields.thresholdLower) >= Number(fields.thresholdUpper)) {
          throw t("invalid_threshold_warning");
        }
      }
    } catch (message: any) {
      alerting("warning", message);
      return false;
    }

    return true;
  };

  return { validate };
}

export default useValidation;
